import BackofficeImportsBase from './BackofficeImportsBase';

export default class BackofficeStudyRequestImportsIndex extends BackofficeImportsBase {
    constructor() {
        super({
            // Checkbox selectors
            checkboxSelector: '[data-study-checkbox]',
            checkboxAllSelector: '[data-study-checkbox-all]',
            
            // Bulk actions selectors
            bulkActionsContainerSelector: '[data-study-bulk-actions-container]',
            selectedCountSelector: '[data-study-selected-count]',
            bulkValidateSelector: '[data-study-bulk-validate]',
            bulkInvalidateSelector: '[data-study-bulk-invalidate]',
            bulkDeleteSelector: '[data-study-bulk-delete]',
            bulkArchiveSelector: '[data-study-bulk-archive]',
            bulkUnarchiveSelector: '[data-study-bulk-unarchive]',
            
            // Retry import selectors
            retryImportButtonSelector: '[data-study-retry-import]',
            retryImportModalId: 'studyRetryImportModal',
            fileInputId: 'study_csv_file',
            confirmCheckboxId: 'study_confirm_import',
            confirmRetryButtonSelector: '[data-study-confirm-retry-import]',
            
            // URLs
            bulkValidateUrl: '/study_request_imports/bulk_validate',
            bulkInvalidateUrl: '/study_request_imports/bulk_invalidate',
            bulkDestroyUrl: '/study_request_imports/bulk_destroy',
            bulkArchiveUrl: '/study_request_imports/bulk_archive',
            bulkUnarchiveUrl: '/study_request_imports/bulk_unarchive',
            retryImportUrl: '/study_request_imports/retry_import',
            
            // Item configuration
            itemIdParamName: 'study_request_ids[]',
            itemName: 'demande d\'étude',
            itemNamePlural: 'demande(s) d\'étude'
        });
    }
}
